@if (type) {
  <div [class.bg-green-500]="type === 'confirm'"
    [class.bg-red-500]="type === 'error'"
    [class.bg-yellow-500]="type === 'alert'"
    [class.bg-blue-500]="type === 'success'"
    class="fixed bottom-0 w-full flex-auto right-0 p-4 rounded shadow-md animate-fade-up animate-duration-500 animate-ease-in">
    <p class="text-white"  style="text-align: right;">{{ message }}</p>
  </div>
}
